import { render, staticRenderFns } from "./TreeDots.vue?vue&type=template&id=c0eceffe&scoped=true"
import script from "./TreeDots.vue?vue&type=script&lang=js"
export * from "./TreeDots.vue?vue&type=script&lang=js"
import style0 from "./TreeDots.vue?vue&type=style&index=0&id=c0eceffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0eceffe",
  null
  
)

export default component.exports